import {useEffect, useState} from 'react';

// import {useApp} from './useApp'; //TODO

type UseElementVisibleInViewportType = (props: {duration?: number; threshold?: number}) => {
  isIntersecting: boolean;
  setNodeRef: (node: Element | null) => void;
};

const DEFAULT_DURATION = 3000;
const DEFAULT_THRESHOLD = 1;

export const useElementVisibleInViewport: UseElementVisibleInViewportType = ({
  duration = DEFAULT_DURATION,
  threshold = DEFAULT_THRESHOLD
}) => {
  //const {headerHeight} = useApp(); //TODO
  const headerHeight = 0;
  const [isIntersecting, setIntersecting] = useState(false);
  const [nodeRef, setNodeRef] = useState<Element | null>(null);
  const rootMargin = `-${headerHeight}px 0px 0px 0px`;

  useEffect(() => {
    let timeoutId: NodeJS.Timeout;
    const observer = new IntersectionObserver(
      ([entry]) => {
        if (entry.isIntersecting) {
          // Clear previous timeout if any
          clearTimeout(timeoutId);

          // Set a timeout to set visibility after a duration
          timeoutId = setTimeout(() => {
            setIntersecting(entry.isIntersecting);
          }, duration);
        } else {
          // If the element is not intersecting, clear the timeout
          clearTimeout(timeoutId);
          setIntersecting(false);
        }
      },
      {
        threshold,
        rootMargin
      }
    );

    if (nodeRef) {
      observer.observe(nodeRef);
    }

    return () => {
      if (observer) {
        observer.disconnect();
      }
    };
  }, [duration, nodeRef, threshold, rootMargin]);
  return {isIntersecting, setNodeRef};
};
